const prefix = "add-cake";
export const ADD_CAKE_MESSAGE_PILL_TEST_IDS = {
    PILL_TEXT: `${prefix}-pill-text`,
    PILL_CONTAINER: `${prefix}-pill-container`,
};
